
require(["../src/js/buildframe/kickstart"]);
